<template>
  <div class="service-company-share-bd tb">
    <div class="search-content">
      <el-form :inline="true" @submit.native.prevent label-position="top">
        <el-form-item :label="$t('report_serviceCompanyShare.ji_suan_jie_dian')">
          <el-date-picker format="yyyy-MM" value-format="yyyy-MM" :picker-options="pickerOptionsMonth"
            v-model="formSearch.timeNode" type="month" :clearable="false">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('report_serviceCompanyShare.fen_tan_qu_jian')">
          <el-date-picker style="width: 100%" :clearable="false" format="yyyy-MM" value-format="yyyy-MM"
            v-model="formSearch.allocationInterval" type="monthrange"
            @change="onAllocationIntervalChange"></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('report_serviceCompanyShare.kai_piao_ri_qi')">
          <custom-date-picker style="width: 100%" :clearable="false" v-model="formSearch.invoiceDate"
            :initValue="formSearch.defaultInvoiceDate" type="daterange" value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="beforeToday"></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('report_serviceCompanyShare.he_tong_bian_hao')">
          <el-input v-model="formSearch.contractNo" placeholder=""></el-input>
        </el-form-item>
        <el-form-item :label="$t('report_serviceCompanyShare.ke_hu_ming_cheng')">
          <el-input v-model="formSearch.customerName" placeholder=""></el-input>
        </el-form-item>
        <el-form-item :label="$t('report_serviceCompanyShare.shou_hou_gong_si')">
          <el-input v-model="formSearch.afterServiceName" placeholder=""></el-input>
        </el-form-item>
        <el-form-item :label="$t('report_serviceCompanyShare.ji_shen_hao')">
          <el-input v-model="formSearch.bodyNum" placeholder=""></el-input>
        </el-form-item>
        <el-form-item :label="$t('report_serviceCompanyShare.fa_piao_bian_hao')">
          <el-input v-model="formSearch.invoiceNum" placeholder=""></el-input>
        </el-form-item>
        <!-- 后端说不支持-收款日期 -->
        <!-- <el-form-item :label="$t('p_serviceCompanyShare_shou_kuan_ri_qi')">
          <el-date-picker v-model="formSearch.shouKuanRiQi" value-format="yyyy-MM" type="monthrange" :range-separator="$t('p_serviceCompanyShare_zhi')"
            :start-placeholder="$t('p_serviceCompanyShare_kai_shi_yue_fen')" :end-placeholder="$t('p_serviceCompanyShare_jie_shu_yue_fen')">
          </el-date-picker>
        </el-form-item> -->
      </el-form>
    </div>
    <div class="footer">
      <div class="button-group">
        <el-button @click="onReset">{{ $t('Common.com_reset') }}</el-button>
        <el-button type="primary" @click="onExport">{{ $t('Common.com_export') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import apis from '@/utils/apis';

export default {
  name: '',
  mixins: [],
  components: {
  },
  props: {
  },
  data() {
    return {
      formSearch: {
        // 计算节点
        timeNode: '',
        // 分摊区间
        allocationInterval: '',
        // 开票日期
        invoiceDate: '',
        initInvoiceDate: '',
        // 合同编号
        contractNo: '',
        // 客户名称
        customerName: '',
        // 售后公司
        afterServiceName: '',
        // 机身号
        bodyNum: '',
        // 发票编号
        invoiceNum: '',
        // 收款日期
        shouKuanRiQi: '',
      },
      pickerOptionsMonth: {
        disabledDate: time => moment(time).isAfter(this.getLocalTime(), 'day'),
      },
    };
  },
  computed: {
  },
  watch: {
  },
  filters: {
  },
  directives: {
  },
  methods: {
    fixZero(num) {
      if (typeof num === 'string') {
        if (num.length > 1) {
          return num;
        }
        return ['0', num].join('');
      } else {
        if (num >= 10) {
          return num;
        }
        return ['0', num].join('');
      }
    },
    onAllocationIntervalChange() {
      const startDate = this.formSearch.allocationInterval[0].split('-');
      const endDate = this.formSearch.allocationInterval[1].split('-');

      const startDateObj = {
        year: Number(startDate[0]),
        month: Number(startDate[1])
      };
      const endDateObj = {
        year: Number(endDate[0]),
        month: Number(endDate[1])
      };
      const endDateMonth = endDateObj.year * 12 + endDateObj.month;
      const stateDateMonth = startDateObj.year * 12 + startDateObj.month;

      if (endDateMonth - stateDateMonth > 36) {
        // 结束年月  与 开始年月 跨度不能超过36个月
        setTimeout(() => {
          const newEndDateObj = {
            year: startDateObj.year + 3,
            month: startDateObj.month,
          };

          this.formSearch.allocationInterval = [
            `${startDateObj.year}-${this.fixZero(startDateObj.month)}`,
            `${newEndDateObj.year}-${this.fixZero(newEndDateObj.month)}`,
          ];
        }, 500);
      }
    },
    getLastMonth() {
      var now = new Date();
      var time = new Date(
        now.getFullYear(),
        now.getMonth() - 1,
        now.getDate(),
      );
      return time;
    },
    getLocalTime() {
      var time = this.getLastMonth();
      return this.$momentElLocal(time.getTime());
    },

    // 初始化：计算节点
    initTimeNode() {
      const lastMonthDate = this.getLastMonth();
      const val = moment(lastMonthDate).format('YYYY-MM');
      this.formSearch.timeNode = val;
    },

    // 初始化：分摊区间
    initAllocationInterval() {
      var now = new Date();
      var lastYear = new Date(
        now.getFullYear() - 1,
        now.getMonth(),
        now.getDate(),
      );
      var nextYear = new Date(
        now.getFullYear() + 1,
        now.getMonth(),
        now.getDate(),
      );
      this.formSearch.allocationInterval = [
        moment(lastYear).format('YYYY-MM'),
        moment(nextYear).format('YYYY-MM')
      ];
    },
    // 初始化：开票日期
    initInvoiceDate() {
      const now = new Date();
      const start = new Date(
        now.getFullYear(),
        now.getMonth() - 1,
        1
      );
      const end = new Date(
        now.getFullYear(),
        now.getMonth(),
        1
      );
      end.setDate(0);

      this.formSearch.defaultInvoiceDate = [
        moment(start).format('YYYY-MM-DD'),
        moment(end).format('YYYY-MM-DD')
      ];
    },
    onReset() {
      this.formSearch = {
        // 计算节点
        timeNode: '',
        // 分摊区间
        allocationInterval: '',
        // 开票日期
        invoiceDate: '',
        defaultInvoiceDate: '',
        // 合同编号
        contractNo: '',
        // 客户名称
        customerName: '',
        // 售后公司
        afterServiceName: '',
        // 机身号
        bodyNum: '',
        // 发票编号
        invoiceNum: '',
        // 收款日期
        // shouKuanRiQi: '',
      };
      this.initTimeNode();
      this.initAllocationInterval();
      this.initInvoiceDate();
    },
    onExport() {
      const ret = this.getSubmitData();
      this.$exportFliePost(apis.invoiceAllocationAmountControllerExport, ret).catch((e) => {
        if (e.code !== 200) {
          this.$message({
            message: e.msg,
            type: 'error',
            duration: 3000,
          });
        }
      });
    },
    getSubmitData() {
      const {
        timeNode,
        allocationInterval,
        invoiceDate,
        invoiceNum,
        bodyNum,
        afterServiceName,
        customerName,
        contractNo,
      } = this.formSearch;

      const ret = {
        invoiceNum,
        bodyNum,
        afterServiceName,
        customerName,
        contractNo,
      };
      ret.timeNode = this.formatYM(timeNode);
      ret.allocationInterval = [
        this.formatYM(allocationInterval[0]),
        this.formatYM(allocationInterval[1]),
      ];
      ret.invoiceDate = invoiceDate;

      return ret;
    },

    /**
     * 本地yyyy-mm 转为 世界时间的 yyyy-mm-dd hh:mm:ss
     * @param {String} str yyyy-mm 格式的日期字符串
     * @return {String} yyyy-mm-dd hh:mm:ss的日期格式字符串
     */
    formatYM(str) {
      const arr = str.split('-');
      const year = Number(arr[0]);
      const month = Number(arr[1]);
      const dateStr = `${year}-${month > 9 ? month : [0, month].join('')}-01 00:00:00`;
      return this.$momentWorld(dateStr);
    }
  },
  created() {
  },
  mounted() {

    this.initTimeNode();
    this.initAllocationInterval();
    this.initInvoiceDate();
  },
};
</script>

<style lang="scss">
.service-company-share-bd {
  padding-top: 16px !important;
  overflow: hidden;

  .el-form-item {
    width: 25%;
    margin: 0 !important;
    margin-bottom: 0px !important;
    padding: 0 8px;

    // .el-input__inner {
    //   border: none !important;
    // }
  }

  // .el-input.is-disabled .el-input__inner {
  //   background-color: #fcfcfc;
  // }


  .el-form-item--small .el-form-item__label {
    margin-top: 16px;
    font-size: 12px;
    padding: 0px 0px 4px 0 !important;
    color: #495057;
    line-height: 24px;
  }

  .el-date-editor.el-input {
    width: 100% !important;
  }

  .footer {
    overflow: hidden;
    margin-top: 10px;
  }

  .button-group {
    padding: 8px;
    float: right;

  }
}
</style>
